import { render, staticRenderFns } from "./MemberTransaction.vue?vue&type=template&id=88e2c2f2&scoped=true"
import script from "./MemberTransaction.vue?vue&type=script&lang=js"
export * from "./MemberTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e2c2f2",
  null
  
)

export default component.exports